import {
  Button,
  ButtonVariants,
  Typography,
} from '../../components/primitives';
import Alert from '../../components/ui/Alert';
import ContactSupport from '../../components/ui/ContactSupport';
import { testId } from '../../utils';
import { PageCard } from './PageCard';
import { Cornerstone } from '@rpi/api';
import { Trans, useTranslation } from '@rpi/i18n';
import React, { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const ConfirmSignUpRoute: React.FC = () => {
  const email = useEmail();

  const { t } = useTranslation(undefined, { keyPrefix: 'route.auth' });

  const { mutate, isSuccess, isLoading } =
    Cornerstone.useRequestRegistrationToken();

  const onClickResend = useCallback(() => {
    if (!email) {
      // User will be redirected
      return;
    }
    mutate({
      data: {
        email,
      },
    });
  }, [mutate, email]);

  return (
    <PageCard className="flex flex-col gap-6 text-center">
      {isSuccess && (
        <Alert {...testId('alert')} variant="success">
          {t('verification_link_sent')}
        </Alert>
      )}
      <Typography variant="title-default">
        {t('confirm_sign_up_title')}
      </Typography>
      <Typography variant="body">
        <Trans i18nKey={t('confirm_sign_up')} values={{ email }} />
      </Typography>
      <Typography variant="body">
        <Trans i18nKey={t('missing_reg_email')} />
      </Typography>
      <div className="flex flex-col gap-2">
        <Typography variant="body">
          <Trans i18nKey={t('resend_verification')} />
        </Typography>
        <Button
          {...testId('resend')}
          variant={ButtonVariants.Secondary}
          onClick={onClickResend}
          loading={isLoading}
        >
          Resend
        </Button>
      </div>
      <ContactSupport />
    </PageCard>
  );
};

function useEmail() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || null;
  const navigate = useNavigate();
  useEffect(() => {
    if (!email) {
      navigate('/auth/sign-in', { replace: true });
    }
  }, [email, navigate]);
  return email;
}
